import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { Modal, Typography, Form, Input, Row, Col, message, Select} from 'antd';
import axios from 'axios';
import { createUser } from 'requests/user';
import BaseSelect from 'components/Elements/BaseSelect';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

const OrderViewCardOrders = (props) => {
	const { visible, onClose, onSubmit } = props;
	const [loading, setLoading] = useState(false);
	const [roles, setRoles] = useState([]);
	const [selectedRole, setSelectedRole] = useState(null);
	const [formRef] = Form.useForm();
	const token = localStorage.getItem('token');
	const { Title } = Typography;

	const onSubmitData = () => {
		formRef.validateFields().then(async (data) => {
			try {
				setLoading(true);
	
				const payload = {
					name: data.name,
					status: data.status,
				};
	
				await axios.post(
					'https://billpay.mtmpay.in/Admin/api/admin/bill-category-create',
					payload,
					{
						headers: {
							Authorization: `Bearer ${token}`,
						}
					}
				);
	
				toast.success("Bill Category created successfully!");
				onCancel();
				onSubmit && onSubmit();
				setTimeout(() => {
					window.location.reload();
				}, 1500); 
			} catch (err) {
				console.error(err);
				toast.error(err.response?.data?.message || "Failed to create user");
			} finally {
				setLoading(false);
			}
		});
	};

	const onCancel = () => {
		formRef.resetFields();
		setRoles([]);
		setSelectedRole(null);
		onClose();
	};

	return (
		<Modal
			title={'Create new bill category'}
			open={visible}
			closable={false}
			onCancel={onCancel}
			onOk={onSubmitData}
			okButtonProps={{ loading: loading }}
			okText="Submit"
			width={700}
		>
			<Form layout="vertical" form={formRef} autoComplete="off">
				<Row gutter={[16, 16]}>
					<Col lg={12} md={12} sm={24} xs={24}>
						<Form.Item name="name" label="name" rules={[{ required: true }]}>
							<Input />
						</Form.Item>
					</Col>
					<Col lg={12} md={12} sm={24} xs={24}>
						<Form.Item
							name="status"
							label="Status"
							initialValue={1}
						>
							<Select>
								<Select.Option value={1}>Active</Select.Option>
								<Select.Option value={0}>Inactive</Select.Option>
							</Select>
						</Form.Item>
					</Col>
				</Row>
			</Form>
		</Modal>
	);
	<ToastContainer />
};

OrderViewCardOrders.propTypes = {
	visible: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onSubmit: PropTypes.func.isRequired,
};

export default OrderViewCardOrders;
